export default "__VITE_ASSET__f05dc7f0__"